import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { PavingViewControllerDelegate, PavingViewController } from "../../Screen/Paving/PavingViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { PavingViewModel } from '../../Screen/Paving/PavingViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class PavingCoordinator implements IndexCoordinatorDelegate, PavingViewControllerDelegate, TableGenericViewControllerDelegate {
    
    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("geppavimentacao")
        return (<ProtectedRoute path="/:base/pavimentacao" exact={true} component={(props: any) => {
            return (<TableGenericViewController 
                navigation={props} 
                viewModel={viewModel} 
                delegate={this} 
                title={"Pavimentação"}
            />)
        }}/>)
    }

    private routeForm(): JSX.Element {
        var viewModel = new PavingViewModel()
        return (<ProtectedRoute path="/:base/pavimentacao/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<PavingViewController navigation={props} viewModel={viewModel} delegate={this} idPrimary={idPk}/>)
        }}/>)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }
    
    add(navigation: any, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "geppavimentacao") {
            navigation.history.push(`pavimentacao/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "geppavimentacao") {
            navigation.history.push(`pavimentacao/cad/${idSelection}`);
            return;
        }
    }

}